import { Box, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Typography, useMediaQuery, useTheme, Link as MuiLink } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import ReceiptModal from "../ReceiptModal";
import { Link as RouterLink } from "react-router-dom";
import { ModalLoader } from "../../Atoms/ModalLoader";
import { Pagination } from "@mui/lab";
import moment from "moment";
import {
  formatCurrency,
  formatCurrencyColor,
  formatCurrencyType,
} from "../../../Utils/formatters";
import { useAuth } from "../../../Contexts/AuthContext";

export const ReceiptList = ({
  itens,
  loading,
  type,
  hasFilter,
  title,
  headerLink,
  handleChangePage,
  page,
}) => {
  const useStyles = makeStyles({
    list: {
      paddingBottom: 0,
      borderRadius: 5,
      overflowY: "auto",
      minHeight: 50,
      maxHeight: "100%",
    },
  });

  const matches = useMediaQuery("(min-width: 460px)");
  const theme = useTheme();
  const classes = useStyles();
  const [selectedItem, setSelectedItem] = useState({});
  const [inputFilterValue, setInputFilterValue] = useState("");
  const [viewReceiptDetails, setViewReceiptDetails] = useState(false);

  const { hasPermission } = useAuth();

  const handleClickItem = (item) => {
    setSelectedItem(item?.receipt);
    setViewReceiptDetails(true);
  };

  const handleCloseDetails = () => {
    setViewReceiptDetails(false);
    setSelectedItem({});
  };

  if (loading) {
    return <ModalLoader open={loading} text={"Carregando informações"} />;
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          padding: headerLink ? "30px 20px" : 0,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {!!headerLink && hasPermission('statementsview') && (
          <>
            <Typography variant="h6" color="text.primary" sx={{ m: 0 }}>
              {title}
            </Typography>
            <MuiLink component={RouterLink} underline="hover" color="primary.main" to={headerLink} sx={{ fontSize: 16 }}>
              Ver mais
            </MuiLink>
          </>
        )}
      </div>

      <List dense className={classes.list}>
        {itens.items?.length === 0 ? (
          <Box component="span" display="flex" justifyContent="center" m={1}>
            Nenhum resultado encontrado.
          </Box>
        ) : (
          itens.items?.map((receipt) => {
            if (receipt) {
              const day = Object.keys(receipt)[0];
              const listReceipt = receipt[day];

              return (
                <>
                  {listReceipt.map((item, index) => {
                    const el = {
                      ...item,
                      title: item?.description,
                      date: moment(item?.created_at).format(
                        "DD/MM/YYYY [às] HH:mm"
                      ),
                      dayDate: moment(item?.created_at).format("DD/MM/YYYY"),
                      value: formatCurrency(Math.abs(item?.amount)),
                      balance_after: formatCurrency(
                        Math.abs(item?.balance_after)
                      ),
                      balance_before: formatCurrency(
                        Math.abs(item?.balance_before)
                      ),
                      valueColor: formatCurrencyColor(item?.amount),
                      type: formatCurrencyType(item?.amount),
                      icon: item?.category?.icon,
                    };
                    return (
                      <>
                        {index === 0 ? (
                          <ListItem
                            style={{
                              backgroundColor: theme.palette.action.hover,
                              border: `1px solid ${theme.palette.divider}`,
                              borderRadius: 6,
                              padding: 8,
                              margin: '4px 0',
                              flexDirection: 'row',
                              alignItems: 'center',
                              gap: 8,
                            }}
                          >
                            <ListItemText
                              primary={
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography variant="body2" color="text.secondary">
                                    {el.dayDate}
                                  </Typography>
                                  <Typography variant="body2" component="span">
                                    <strong>Saldo inicial do dia</strong>
                                  </Typography>
                                </Box>
                              }
                              style={{
                                paddingTop: 0,
                                height: "100%",
                                textAlign: matches ? "inherit" : "left",
                                flex: 1,
                                marginRight: 8,
                              }}
                            />
                            <Box style={{ marginLeft: 'auto' }}>
                              <Typography variant="body2">
                                <strong>{el.balance_before}</strong>
                              </Typography>
                            </Box>
                          </ListItem>
                        ) : null}
                        <ListItem
                          key={index.toString()}
                          style={{
                            cursor: type === "receipts" ? "pointer" : "default",
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            padding: 12,
                            flexDirection: matches ? "row" : "column",
                          }}
                          onClick={() =>
                            type === "receipts" ? handleClickItem(el) : ""
                          }
                        >
                          {matches && (
                            <ListItemIcon
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                padding: 0,
                                minWidth: 36,
                                marginRight: 8,
                              }}
                            >
                              <img src={el?.icon} height={26} width="auto" />
                            </ListItemIcon>
                          )}
                          <ListItemText
                            primary={<strong>{el?.title}</strong>}
                            secondary={
                              <Typography variant="body2" style={{ textAlign: matches ? "inherit" : "left" }}>
                                {el?.date}
                              </Typography>
                            }
                            style={{
                              paddingTop: "4px",
                              height: "100%",
                              textAlign: matches ? "inherit" : "left",
                              width: "100%",
                            }}
                          />
                          {matches ? (
                            <ListItemSecondaryAction
                              style={{
                                justifyContent: "start",
                                top: "50%",
                              }}
                            >
                              <Typography
                                variant="body1"
                                style={{ color: el?.valueColor }}
                              >
                                {el?.value}
                              </Typography>
                            </ListItemSecondaryAction>
                          ) : (
                            <Box
                              mt={1}
                              width="100%"
                              display="flex"
                              justifyContent="flex-end"
                            >
                              <Typography
                                variant="body1"
                                style={{ color: el?.valueColor }}
                              >
                                {el?.value}
                              </Typography>
                            </Box>
                          )}
                        </ListItem>
                        {index === listReceipt.length - 1 ? (
                          <ListItem
                            style={{
                              backgroundColor: theme.palette.action.hover,
                              border: `1px solid ${theme.palette.divider}`,
                              borderRadius: 6,
                              padding: 8,
                              margin: '4px 0',
                              flexDirection: 'row',
                              alignItems: 'center',
                              gap: 8,
                            }}
                          >
                            <ListItemText
                              primary={
                                <Box display="flex" alignItems="center" gap={1}>
                                  <Typography variant="body2" color="text.secondary">
                                    {el.dayDate}
                                  </Typography>
                                  <Typography variant="body2" component="span">
                                    <strong>Saldo final do dia</strong>
                                  </Typography>
                                </Box>
                              }
                              style={{
                                paddingTop: 0,
                                height: "100%",
                                textAlign: matches ? "inherit" : "left",
                                flex: 1,
                                marginRight: 8,
                              }}
                            />
                            <Box style={{ marginLeft: 'auto' }}>
                              <Typography variant="body2">
                                <strong>{el.balance_after}</strong>
                              </Typography>
                            </Box>
                          </ListItem>
                        ) : null}
                      </>
                    );
                  })}
                </>
              );
            }
            return <></>;
          })
        )}
      </List>
      {(type === "extract" || type === "receipts") &&
        itens.items?.length > 0 && (
          <Box mt={2} mb={1} ml={2}>
            <Pagination
              count={itens.pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        )}
      {type === "receipts" && (
        <ReceiptModal
          type={type}
          open={viewReceiptDetails}
          onClose={handleCloseDetails}
          selectedItem={selectedItem}
        />
      )}
    </>
  );
};

ReceiptList.propTypes = {};
